
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/design-system/examples/entries-and-stats",
      function () {
        return require("private-next-pages/design-system/examples/entries-and-stats.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/design-system/examples/entries-and-stats"])
      });
    }
  